var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, Component, useEffect, } from 'react';
import { useDropzone } from 'react-dropzone';
import { classnames, bem, use } from '../../lib';
import { DropzoneBox } from './DropzoneBox';
function wrapCallback(callback) {
    return useCallback(callback, [callback]);
}
function hydrateDataUrl(files, asText = false) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!FileReader)
            return null;
        const results = files.map((file) => {
            return new Promise((resolve) => {
                const fileReader = new FileReader();
                fileReader.onload = () => {
                    if (asText)
                        file.text = fileReader.result;
                    else
                        file.dataUrl = fileReader.result;
                    resolve(file);
                };
                asText ? fileReader.readAsText(file) : fileReader.readAsDataURL(file);
            });
        });
        return yield Promise.all(results);
    });
}
const DropzoneComponent = (_a) => {
    var { asText, className, children, fluid, onChange, getOpen } = _a, dropzoneOptions = __rest(_a, ["asText", "className", "children", "fluid", "onChange", "getOpen"]);
    const onChangeHandler = useCallback(onChange, [onChange]);
    const onDropAccepted = useCallback(dropzoneOptions.onDropAccepted, [
        dropzoneOptions.onDropAccepted,
    ]);
    const handleDropAccepted = useCallback((files, event) => {
        hydrateDataUrl(files, asText).then((dzFiles) => {
            if (onChangeHandler)
                onChangeHandler(dzFiles, event);
            if (onDropAccepted)
                onDropAccepted(dzFiles, event);
        });
    }, [onChangeHandler, onDropAccepted]);
    const { getInputProps, getRootProps, isFocused, isDragActive, isDragAccept, isDragReject, isFileDialogActive, open, } = useDropzone(Object.assign(Object.assign({}, dropzoneOptions), { onDropAccepted: handleDropAccepted, onDragEnter: wrapCallback(dropzoneOptions.onDragEnter), onDragLeave: wrapCallback(dropzoneOptions.onDragLeave), onDragOver: wrapCallback(dropzoneOptions.onDragOver), onDrop: wrapCallback(dropzoneOptions.onDrop), onDropRejected: wrapCallback(dropzoneOptions.onDropRejected), onFileDialogCancel: wrapCallback(dropzoneOptions.onFileDialogCancel) }));
    useEffect(() => {
        if (getOpen) {
            getOpen(open);
        }
    }, []);
    const clsName = bem('dropzone', use(fluid, '--fluid'), use(isFocused, '--focussed'), use(isDragActive, '--drag-active'), use(isDragAccept, '--drag-accepted'), use(isDragReject, '--drag-rejected'), use(isFileDialogActive, '--dialog-active'));
    return (React.createElement("div", Object.assign({}, getRootProps(), { tabIndex: -1, className: classnames(clsName, className) }),
        React.createElement("input", Object.assign({}, getInputProps(), { className: bem('dropzone__input') })),
        children));
};
let Dropzone = /** @class */ (() => {
    class Dropzone extends Component {
        render() {
            return React.createElement(DropzoneComponent, Object.assign({}, this.props));
        }
    }
    Dropzone.Box = DropzoneBox;
    return Dropzone;
})();
export { Dropzone };
//# sourceMappingURL=Dropzone.js.map